import styled from "styled-components";

export const HeaderContainer = styled.header`
  width: 100%;
  background: ${props => props.theme.colors.cardBackground};
  position: fixed;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px ${props => props.theme.colors.shadow}; 
  transition: all 0.3s ease;
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

export const HeaderContent = styled.div`
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  padding: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 60px;

  @media (max-width: 1200px) {
    padding: 3rem 2.5rem;
  }

  @media (max-width: 992px) {
    padding: 3rem 1.25rem;
  }

  @media (max-width: 768px) {
    padding: 1rem 0.75rem;
    height: auto;
    min-height: 60px;
    /* Mobilde: Logo - boş alan - Menü düzeni */
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }

  @media (max-width: 576px) {
    padding: 1rem 0.75rem;
  }
`;

export const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    /* Mobilde NavWrapper gizle */
    display: none;
  }
`;

export const MobileRightSection = styled.div`
  /* Desktop'ta sadece toggle göster */
  display: flex;
  align-items: center;

  /* Mobile navigation gizle */
  .mobile-nav {
    display: none;
  }

  @media (max-width: 768px) {
    /* Mobilde sağ tarafta dikey stack */
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
    
    /* Mobile navigation göster */
    .mobile-nav {
      display: block;
    }
  }
`;